import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { MYSHOP_FEATURE, MyShopState, StateWithMyShop } from '../my-shop-state';

export const getMyShopFeature: MemoizedSelector<StateWithMyShop, MyShopState> =
  createFeatureSelector<MyShopState>(MYSHOP_FEATURE);

export const getMyShopName: MemoizedSelector<StateWithMyShop, string | undefined> = createSelector(
  getMyShopFeature,
  (state: MyShopState) => state.pointOfService.name,
);

export const getMyShopInit: MemoizedSelector<StateWithMyShop, boolean> = createSelector(
  getMyShopFeature,
  (state: MyShopState) => state.pointOfService.init,
);
